module.exports = __webpack_public_path__ + "static/media/no_messages_icon.460a8c06.svg";